module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('headerpage', {
    attrs: {
      "status": 0
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "deground"
  }, [_c('div', {
    staticClass: "adaptation",
    staticStyle: {
      "background-color": "#f6f8f7"
    }
  }, [_c('div', {
    staticClass: "hetext"
  }, [_vm._v("首页>政策资讯")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, _vm._l((_vm.tablist), function(item, index) {
    return _c('div', {
      staticClass: "box_cet",
      class: _vm.tabindex == index ? 'box_sty' : '',
      on: {
        "click": function($event) {
          return _vm.tabchange(index)
        }
      }
    }, [_vm._v("\n                " + _vm._s(item.name) + "\n            ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [(_vm.tabindex == 0) ? [_c('consultingpage')] : [_c('bulletinpage')]], 2)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px"
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6aa32472"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/bulletin/list.vue
// module id = 896
// module chunks = 1